export default __webpack_public_path__ + "static/media/dr-maria-rupani.f3681afc.jpg";